import React, { useEffect, useState } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onConsentChange }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after a short delay for better UX
      const t = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(t);
    } else {
      // Load saved preferences
      try {
        const savedPrefs = JSON.parse(consent);
        // Notify parent component
        if (onConsentChange) {
          onConsentChange(savedPrefs);
        }
      } catch (e) {
        console.error('Failed to parse cookie consent:', e);
      }
    }
  }, [onConsentChange]);

  const saveConsent = (prefs) => {
    localStorage.setItem('cookie_consent', JSON.stringify(prefs));
    setShowBanner(false);

    // Notify parent component
    if (onConsentChange) {
      onConsentChange(prefs);
    }
  };

  const handleAcceptAll = () => {
    saveConsent({
      necessary: true,
      analytics: true,
    });
  };

  const handleRejectAll = () => {
    saveConsent({
      necessary: true,
      analytics: false,
    });
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <p>
            We use essential cookies to make this site work, and optional analytics cookies to understand traffic.{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
            .
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button className="cookie-btn cookie-btn-reject" onClick={handleRejectAll}>
            Reject optional
          </button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAcceptAll}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
